export const ROUTES_PATH = {
  RULE_PATH: '/v3/rules/',
  RULE_DETAIL_PATHS: '/v3/rule-details/',
  RESOURCES: '/v3/resources-cost/',
  TAG_EXPLORER: '/v3/cost/tag-explorer/',
  CHARGEBACKS: '/v3/cost/chargeback/',
  CHARGEBACKS_V2: '/v3/cost/chargebacks-center-legacy/',
  CHARGEBACK_CENTER: '/v3/cost/chargebacks-center/',
  CHARGEBACK_CENTER_V2: '/v3/cost/chargebacks-center-legacy/',
  RECOMMENDATIONS: '/v3/cost/recommendations/',
  WORKLOAD_V2: '/v3/workload-v2/',
  ESSENTIALS_SHARESAVE: '/v3/essentials/summary/',
  SCHEDULER_DASHBOARD: '/v3/essentials/scheduler/',
  STORAGE_DASHBOARD: '/v3/essentials/storage/',
  RIGHTSIZING_DASHBOARD: '/v3/essentials/rightsizing/',
  IDLE_RESOURCES_DASHBOARD: '/v3/essentials/idle-resources/',
  CM_SUMMARY: '/v3/compute-copilot/summary/',
  CM_DASHBOARD: '/v3/compute-copilot/cm/dashboard/',
  EKS_DASHBOARD: '/v3/compute-copilot/eks/dashboard/',
  EKS_DETAILS: '/v3/compute-copilot/eks/details/',
  ASG_DASHBOARD: '/v3/compute-copilot/asg/dashboard/',
  VISIBILITY_DASHBOARD: '/v3/compute-copilot/visibility-dashboard/',
  CONTAINER_RIGHTSIZING: '/v3/compute-copilot/container-rightsizing/',
  CONTAINER_SCHEDULER_DASHBOARD: '/v3/compute-copilot/container-scheduler/',
  CRI_DASHBOARD: '/v3/convertible-ri/',
  FORECAST_PAGE: '/v3/business-contexts/forecast/',
  CRI_ANALYSIS: '/v3/cri-analysis/',
  COST_ANALYSIS: '/v3/cloud-resource-cost-api/',
  COST_EXPLORER: '/v3/cost-explorer/',
  COST_ANALYSIS_REPORTS: '/v3/reports-api/',
  CREATE_TARGET: '/v3/create-target/',
  COST_ANALYSIS_TARGETS: '/v3/targets-api/',
  COST_ALLOCATIONS: '/v3/cost/showbacks-api/',
  COST_ALLOCATIONS_DETAIL: '/v3/cost/showbacks-detail-api/',
  COST_ALLOCATIONS_RESOURCE: '/v3/cost/showbacks-allocation-api/',
  COMMITMENT_INVENTORY: '/v3/cost/reserved/',
  HOME: '/v3/home',
  ORGANIZATION_OVERVIEW: '/v3/organization-overview',
  CUSTOMISED_DASHBOARD: '/v3/dashboards/',
  BURN_DOWN_TRACKER: '/v3/burn-down-tracker/',
  BUSINESS_UNIT_ECONOMICS: '/v3/business-unit-economics/',
  CLARA: '/v3/clara/',
  CLARA_THREADS: '/v3/clara/threads/:threadId',
  CLARA_MESSAGES: '/v3/clara/threads/:threadId/messages',
  CLARA_PROJECTS: '/v3/clara/projects/:projectId',
  CLARA_PROJECT_THREADS: '/v3/clara/projects/:projectId/threads/:threadId',
  FEED: '/v3/feed/',
  FEED_TASK: '/v3/feed/task/',
  FEED_THREAD: '/v3/feed/threads/',
  REFERRAL_PROGRAM: '/v3/referral-program/',
  ADMIN_REFERRAL_DASHBOARD: '/v3/admin/referral-dashboard/',
  CFO_DASHBOARD: '/v3/cfo-dashboard/',
  MAP_DISCOVERY: '/v3/map-discovery/',
  MAP_DISCOVERY_DASHBOARD: '/v3/map-discovery/dashboard',
  DATA_COLLECTION: '/v3/map-discovery/data-collection/',
  WORKLOAD_ANALYSIS: '/v3/map-discovery/workload-analysis/',
  MIGRATION_PLANNING: '/v3/map-discovery/migration-planning/',
  MIGRATION_EXECUTION: '/v3/map-discovery/migration-execution/',
  MAP_MANAGER: '/v3/cost/map-migrated/',
  DEMO_LINK: '/c/switch_demo_client/',
  MAIN_LINK: '/c/switch_main_client/',
};

export const ROUTES_PATH_V2 = {
  EKS_DASHBOARD: '/v3/compute-copilot/v2/eks/dashboard/',
};
